import { MultiSelectMenu, MultiSelectMenuProps } from "./MultiSelectMenu";

export interface MultiSelectInputProps<V extends string | number = string>
  extends MultiSelectMenuProps<V> {
  name: string;
}

export const MultiSelectMenuInput = <V extends string | number = string>({
  name,
  selected,
  ...multiSelectMenuProps
}: MultiSelectInputProps<V>) => (
  <>
    <input type="hidden" name={name} value={selected.join(",")} />
    <MultiSelectMenu selected={selected} {...multiSelectMenuProps} />
  </>
);
